import api from '@/api';

import { HelpConfig } from './HelpConfig.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/HelpConfig`;

export async function getHelpConfig(): Promise<HelpConfig> {
  return api.get(`${CONTROLLER_URL}`, null) as unknown as HelpConfig;
}
